export default __webpack_public_path__ + "static/media/Customer_Filled_Active.3fa5f1df.svg";